import TranslationSwitch from './TranslationSwitch'

export default TranslationSwitch
